/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutWaveState } from './rolloutWaveState';


export interface WaveSummary { 
    state?: RolloutWaveState;
    count?: number;
}
export namespace WaveSummary {
}


